export default __webpack_public_path__ + "static/media/ic_arrow_top.293ca876.svg";